import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=7bf39d68&scoped=true&"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=7bf39d68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf39d68",
  null
  
)

export default component.exports